import React from 'react';
import ProposalPageContent from 'components/proposal-v2/ProposalPageContent';
import { useRootStore } from 'store/rootStore';
import { employerRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import EmployerProposalPageHeader from 'components/proposal-v2/EmployerProposalPageHeader';
import ProposalPageHeader from 'components/proposal-v2/ProposalPageHeader';
import ProposalPageFooter from 'components/proposal-v2/ProposalPageFooter';
import EmployerProposalPageFooter from 'components/proposal-v2/EmployerProposalPageFooter';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { createStyles } from './styles';

const ProposalPage = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    userStore: { userRoles },
  } = useRootStore();

  const convertedRoles = userRoles.map((role) => toJS(role)).slice();
  const isEmployer = employerRights(convertedRoles);

  return (
    <ProposalStatusLayout>
      <div className={classes.proposalContent}>
        {isEmployer ? (
          <>
            <EmployerProposalPageHeader />
            <ProposalPageContent />
            <EmployerProposalPageFooter />
          </>
        ) : (
          <>
            <ProposalPageHeader />
            <ProposalPageContent />
            <ProposalPageFooter />
          </>
        )}
      </div>
    </ProposalStatusLayout>
  );
});

export default ProposalPage;
